import { useCallback } from 'react';

import { useDeleteUserCauseSelection, useShowCauseW_Selector } from 'core/Api';
import { getErrorMessage_v2 } from 'core/Utils';
import { notifications } from 'ui';

import { UnfollowModal } from '../../../Causes/components/FollowButton/UnfollowModal';
import { useCommunicationListsModalProvider } from './CommunicationListsProvider';

const UnfollowCauseModal = () => {
  const { meta, opened, close, closeAllModals, openBack, props } =
    useCommunicationListsModalProvider({
      id: 'Unfollow',
    });
  const { data: cause } = useShowCauseW_Selector({ uuid: meta?.causeId });
  const { mutate: deleteCauseSelection, isPending: isDeletingCauseSelection } =
    useDeleteUserCauseSelection();

  const handleUnfollow = useCallback(() => {
    if (!meta?.causeId) return;

    deleteCauseSelection(
      { causeId: meta.causeId },
      {
        onSuccess: () => {
          notifications.show({
            variant: 'success',
            message: `Unfollowed ${cause?.name || 'this cause'}`,
          });
          openBack();
        },
        onError: (error) => {
          notifications.show({
            variant: 'error',
            message: getErrorMessage_v2(error),
          });
        },
      }
    );
  }, [deleteCauseSelection, meta?.causeId, cause?.name, closeAllModals]);

  return (
    <UnfollowModal
      causeName={cause?.name || 'this cause'}
      opened={opened}
      onClose={close}
      onUnfollow={handleUnfollow}
      onCancel={openBack}
      loading={isDeletingCauseSelection}
      {...props}
    />
  );
};

export { UnfollowCauseModal };
